import isServer from '../isServer';

var isInIframe = function isInIframe() {
  return !isServer() && window.location !== window.parent.location;
};

export default isInIframe;